export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14592.ee3451b8.jpg";